// @flow

import * as React from 'react';
import Group from 'sail/Group';
import Button from 'sail/Button';
import {DemoContainer, Image} from 'docs/components';

import CheckoutPreview from 'docs/images/components/demo/checkout-preview.png';

// No-op for now since this demo is just a static preview
const Result = () => null;

const Demo = () => {
  return (
    <Group>
      <Image src={CheckoutPreview} />
      <Button
        color="blue"
        label="Explore Stripe Checkout"
        href="https://checkout.stripe.dev/"
        width="maximized"
      />
    </Group>
  );
};

export const CheckoutDemo = () => {
  return (
    <DemoContainer
      result={Result}
      demo={Demo}
      name="checkout-one-time-payments"
    />
  );
};
